import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomLayout from "../../../Core/Layout/CustomLayout";
import { PAYMENT_RECEIVER_TYPE } from "../data";
import DriverDetailScreen from "./DriverDetails/DriverDetailScreen";
import FarmerDetailScreen from "./FarmerDetails/FarmerDetailScreen";

const PaymentDetails = () => {
  const navigate = useNavigate();

  const { type } = useParams();

  const { selectedPayment } = useSelector((state) => state.revenue);

  const handlePageNameNavigation = () => {
    navigate("/revenue?tab=payments");
  };

  const getBody = () => {
    if (+type === PAYMENT_RECEIVER_TYPE.DRIVER) return <DriverDetailScreen />;
    if (+type === PAYMENT_RECEIVER_TYPE.FARMER) return <FarmerDetailScreen />;
    return <div />;
  };

  return (
    <CustomLayout
      pageName="Payments"
      nestedName={`${selectedPayment?.firstName} ${selectedPayment?.lastName}`}
      customPageNameNavigation={handlePageNameNavigation}
    >
      {getBody()}
    </CustomLayout>
  );
};

export default PaymentDetails;
